export enum GraphQLErrorCode {
  unauthenticated = 'UNAUTHENTICATED',
  badUserInput = 'BAD_USER_INPUT',
}
